import { readApiError } from './apiError';
import { promptPdfPassword } from './promptPdfPassword';

const PDF_PASSWORD_REQUIRED = 'PDF_PASSWORD_REQUIRED';
const PDF_PASSWORD_INVALID = 'PDF_PASSWORD_INVALID';

/**
 * Runs an upload and, when the server says the PDF needs a user password
 * (PDF_PASSWORD_REQUIRED) or the one given was wrong (PDF_PASSWORD_INVALID),
 * asks the user for it and retries with it. `send` receives the password to
 * pass along as the `pdfPassword` field (undefined on the first attempt).
 * If the user cancels, the original error is rethrown so callers show their
 * normal message. Owner-password-only PDFs never reach the prompt: the server
 * decrypts those on its own.
 */
export const withPdfPassword = async <T>(send: (pdfPassword?: string) => Promise<T>): Promise<T> => {
  let password: string | undefined;
  for (;;) {
    try {
      return await send(password);
    } catch (err) {
      const { code } = await readApiError(err, '');
      if (code !== PDF_PASSWORD_REQUIRED && code !== PDF_PASSWORD_INVALID) throw err;
      const entered = await promptPdfPassword(code === PDF_PASSWORD_INVALID);
      if (entered === null) throw err;
      password = entered;
    }
  }
};
